/**
 * Sends the browser out of the SPA — back to the owner console, which Laravel
 * serves. A module of its own so tests can replace it: jsdom cannot navigate.
 */
export const leaveFor = (url: string): void => {
  window.location.assign(url);
};
